// 관리자 예약 상세에서 손님 결제 QR을 띄우고 결제를 기다리는 창(컨셉 변경 차액·당일 현장 추가)이 함께 쓰는 동작.
// 쓰는 창이 정할 것: data의 phase(시작 단계), methods의 payParam()(손님 결제 화면 주소 이름), statusUrl()(주문을 다시 읽는 주소),
// finish(읽은 주문)(결제됐을 때), focusTarget()(단계마다 초점을 둘 곳)

// 통신이 끊겨도 단추가 도는 채로 갇히지 않게, 이 창의 요청은 이 시간 안에 끝낸다(시간 변경 창과 같은 값).
export const REQUEST_TIMEOUT_MS = 15000
// 손님이 결제했는지 이 간격으로 확인한다. 이 횟수만큼 잇달아 끊기면 직원에게 알린다.
const POLL_MS = 3000
const POLL_FAILURE_ALERT = 3
export const QR_TEXT = {
  waiting: "손님 결제를 기다리고 있습니다.",
  offline: "연결이 끊겨 결제를 확인하지 못하고 있습니다. 인터넷 연결을 확인하고, 손님 휴대폰에 결제 완료 화면이 떴는지 봐 주세요.",
}

export default {
  data: () => ({
    QR_TEXT,
    order: null,
    busy: false,
    errorMessage: "",
    pollFailures: 0,
    timer: null,
    // 창을 닫은 뒤에는 결제 확인을 다시 걸지 않는다
    closed: false,
    // 단추가 잠긴 동안 바뀐 단계는 단추가 풀린 뒤 초점을 옮긴다
    pendingFocus: false,
  }),

  computed: {
    // 테스트 진입점(…_test)에서 띄운 QR은 손님 결제 화면 테스트본으로 보낸다.
    payUrl() {
      const page = location.pathname.includes("_test") ? "addon_test.html" : "addon.html"
      return `${location.origin}/pay/${page}?${this.payParam()}=${this.order.orderId}`
    },
    qrOffline() {
      return this.phase === "qr" && this.pollFailures >= POLL_FAILURE_ALERT
    },
    // 결제 받음 글은 초점이 가서 읽히므로 숨은 알림 자리에는 두지 않는다(두 번 읽히지 않게)
    statusText() {
      return this.phase === "qr" ? QR_TEXT.waiting : ""
    },
  },

  watch: {
    // 누른 단추가 사라지는 단계 전환 뒤에도 초점이 그 단계의 할 일에 가게 한다
    phase() {
      this.focusPhase()
    },
    busy(now) {
      if (!now && this.pendingFocus) this.focusPhase()
    },
  },

  beforeDestroy() {
    this.closed = true
    clearTimeout(this.timer)
  },

  methods: {
    won(value) {
      return `${Number(value || 0).toLocaleString("ko-KR")}원`
    },

    focusPhase() {
      if (this.busy) {
        this.pendingFocus = true
        return
      }
      this.pendingFocus = false
      this.$nextTick(() => {
        const target = this.focusTarget()
        const el = target && (target.$el || target)
        if (el && el.focus) el.focus()
      })
    },

    // 주문을 다시 읽어 결제됐으면 끝낸다. 끊기면 false.
    async checkPaid(timeout = REQUEST_TIMEOUT_MS) {
      try {
        const { data } = await this.$http.get(this.statusUrl(), { timeout })
        this.pollFailures = 0
        if (data.paid && !this.closed) this.finish(data)
        return true
      } catch (error) {
        this.pollFailures += 1
        return false
      }
    },

    // 이 화면에 남겨 둔 주문이 아직 결제 전인지(결제됐거나 읽지 못하면 새 주문을 만든다)
    async stillOpen(order) {
      try {
        const { data } = await this.$http.get(this.statusUrlOf(order), { timeout: REQUEST_TIMEOUT_MS })
        return !data.paid
      } catch (error) {
        return false
      }
    },

    poll() {
      clearTimeout(this.timer)
      this.timer = setTimeout(async () => {
        await this.checkPaid()
        if (this.phase === "qr" && !this.closed) this.poll()
      }, POLL_MS)
    },

    // QR을 띄운 채 닫으면 마지막으로 한 번 더 확인한다. 그새 결제됐으면 닫지 않고 결제 받음을 보인다.
    // 닫을 때 이 창에서 주문을 만들었는지 알린다(상세가 추가 결제·인원을 다시 읽도록: 늦게 끝난 결제, 결제됐는데 안 바뀐 주문)
    async close() {
      if (this.busy) return
      const reload = Boolean(this.order)
      if (this.phase === "qr") {
        clearTimeout(this.timer)
        this.busy = true
        // 연결이 끊긴 상태면 오래 기다리지 않는다
        await this.checkPaid(this.pollFailures >= POLL_FAILURE_ALERT ? 4000 : REQUEST_TIMEOUT_MS)
        this.busy = false
        if (this.phase !== "qr") return
      }
      this.closed = true
      clearTimeout(this.timer)
      this.$emit("close", { reload })
    },
  },
}
